// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.gray {
  color: #292727;
}

.custom-time-picker {
  height: 100%;
  display: flex;
  flex-direction: column;
  margin-bottom: 1.2rem;
}
.custom-time-picker__header {
  display: flex;
  align-items: center;
  padding: 1.5rem;
  border-bottom: 1px solid #efefef;
}
.custom-time-picker__body {
  flex-grow: 1;
  padding: 0px 1.5rem;
}
.custom-time-picker__time-section .time-picker-container {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 1rem;
  position: relative;
}
.custom-time-picker__time-section .time-picker-container .time-column {
  display: flex;
  flex-direction: column;
  align-items: center;
  min-width: 60px;
  cursor: pointer;
  -webkit-user-select: none;
     -moz-user-select: none;
          user-select: none;
  position: relative;
  z-index: 2;
  border-radius: 8px;
}
.custom-time-picker__time-section .time-picker-container .time-column:focus {
  outline: none;
}
.custom-time-picker__time-section .time-picker-container .time-column:focus-visible {
  outline: 2px solid #696969;
  outline-offset: 2px;
}
.custom-time-picker__time-section .time-picker-container .time-column .time-items {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.custom-time-picker__time-section .time-picker-container .time-column .time-items .time-item {
  padding: 0.5rem 1rem;
  font-size: 1.5rem;
  color: #cacacb;
  text-align: center;
  min-height: 2rem;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
  position: relative;
  z-index: 2;
}
.custom-time-picker__time-section .time-picker-container .time-column .time-items .time-item.selected {
  color: #696969;
  border-radius: 8px;
}
.custom-time-picker__time-section .time-picker-container .time-column--period {
  min-width: 65px;
}
.custom-time-picker__time-section .time-picker-container .time-column--period .time-items {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2rem;
}
.custom-time-picker__time-section .time-picker-container .time-column--period .time-items .time-item {
  transition: transform 0.2s ease;
  color: #696969;
}
.custom-time-picker__time-section .time-picker-container .time-column--period .time-items .time-item:first-child {
  transform: translateY(-0.5rem);
}
.custom-time-picker__time-section .time-picker-container .time-column--period .time-items .time-item:first-child.selected {
  transform: translateY(2.5rem);
}
.custom-time-picker__time-section .time-picker-container .time-column--period .time-items .time-item:last-child {
  transform: translateY(0.5rem);
}
.custom-time-picker__time-section .time-picker-container .time-column--period .time-items .time-item:last-child.selected {
  transform: translateY(-2.5rem);
}
.custom-time-picker__time-section .time-picker-container .time-separator {
  font-size: 1.5rem;
  font-weight: 600;
  color: #696969;
  -webkit-user-select: none;
     -moz-user-select: none;
          user-select: none;
  z-index: 2;
}
.custom-time-picker__time-section .time-picker-container .selected-row-background {
  position: absolute;
  left: -16px;
  right: 0;
  height: 3.5rem;
  width: 115%;
  border-radius: 3px;
  background-color: #f5f5f5;
  z-index: 1;
  top: 50%;
  transform: translateY(-50%);
}
.custom-time-picker__footer {
  padding: 1.5rem;
  border-top: 1px solid #efefef;
}`, "",{"version":3,"sources":["webpack://./src/Styles/Colors.scss","webpack://./src/Components/Global/CustomTimePicker/CustomTimePicker.scss"],"names":[],"mappings":"AAsCA;EACE,cArCU;ACAZ;;AACA;EACE,YAAA;EACA,aAAA;EACA,sBAAA;EACA,qBAAA;AAEF;AAAE;EACE,aAAA;EACA,mBAAA;EACA,eAAA;EACA,gCAAA;AAEJ;AACE;EACE,YAAA;EACA,mBAAA;AACJ;AAGI;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,SAAA;EACA,kBAAA;AADN;AAGM;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,eAAA;EACA,eAAA;EACA,yBAAA;KAAA,sBAAA;UAAA,iBAAA;EACA,kBAAA;EACA,UAAA;EACA,kBAAA;AADR;AAGQ;EACE,aAAA;AADV;AAKQ;EACE,0BAAA;EACA,mBAAA;AAHV;AAMQ;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;AAJV;AAMU;EACE,oBAAA;EACA,iBAAA;EACA,cDtDK;ECuDL,kBAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,yBAAA;EACA,kBAAA;EACA,UAAA;AAJZ;AAMY;EACE,cDlEE;ECmEF,kBAAA;AAJd;AAQQ;EACE,eAAA;AANV;AAOU;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,SAAA;AALZ;AAOY;EACE,+BAAA;EACA,cDjFE;AC4EhB;AAOc;EACE,8BAAA;AALhB;AAOgB;EACE,6BAAA;AALlB;AAQc;EACE,6BAAA;AANhB;AAQgB;EACE,8BAAA;AANlB;AAcM;EACE,iBAAA;EACA,gBAAA;EACA,cDzGQ;EC0GR,yBAAA;KAAA,sBAAA;UAAA,iBAAA;EACA,UAAA;AAZR;AAeM;EACE,kBAAA;EACA,WAAA;EACA,QAAA;EACA,cAAA;EACA,WAAA;EACA,kBAAA;EACA,yBAAA;EACA,UAAA;EACA,QAAA;EACA,2BAAA;AAbR;AAkBE;EACE,eAAA;EACA,6BAAA;AAhBJ","sourcesContent":["// Define colors here to use across the site\n\n$textColor: #292727;\n$darkTextColor: #696969;\n$lightTextColor: #cacacb;\n$black: black;\n$borderColor: #c0c0c0;\n$gridBorderColor: #ddd;\n$hoverColor: #b8b8b8;\n$shadow: #9c9c9c;\n$gray: #efefef;\n$darkGray: #515554;\n$backgroundColor: #ffffff;\n$backgroundRight: #ffffff;\n$backgroundLeft: #e9e9e9;\n$success: #18b100;\n$headingsGray: #333333;\n$camelGold: #d0ad4d;\n$gold: #dabc64;\n$iconColor: #9c9c9c;\n$navIcon: #4d4d4d;\n$navIconActive: #dabc64;\n$iconColorActive: #dabc64;\n$magenta: #ab3a72;\n$habitPrimary: rgb(51, 51, 51);\n$habitBorder: rgb(208, 213, 221);\n$habitActionText: rgb(86, 86, 86);\n$habitActionIcon: #565656;\n\n// Brands\n$brand-primary: #3097d1;\n$brand-info: #8eb4cb;\n$brand-success: #2ab27b;\n$brand-warning: #cbb956;\n$brand-danger: red;\n\n$orange: #f5a000;\n\n.gray {\n  color: $textColor;\n}\n\n$input-color: #555;\n\n$headingColor: #999;\n$dayHeadingColor: #555;\n$undoBackground: #bdbdbd;\n","@import '~/Styles/Colors';\n@import '~/Styles/Variables';\n\n.custom-time-picker {\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  margin-bottom: 1.2rem;\n\n  &__header {\n    display: flex;\n    align-items: center;\n    padding: 1.5rem;\n    border-bottom: 1px solid $gray;\n  }\n\n  &__body {\n    flex-grow: 1;\n    padding: 0px 1.5rem;\n  }\n\n  &__time-section {\n    .time-picker-container {\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      gap: 1rem;\n      position: relative;\n\n      .time-column {\n        display: flex;\n        flex-direction: column;\n        align-items: center;\n        min-width: 60px;\n        cursor: pointer;\n        user-select: none;\n        position: relative;\n        z-index: 2;\n        border-radius: 8px;\n\n        &:focus {\n          outline: none;\n        }\n\n        // outline rather than box-shadow so the ring survives forced-colors / high contrast mode\n        &:focus-visible {\n          outline: 2px solid $darkTextColor;\n          outline-offset: 2px;\n        }\n\n        .time-items {\n          display: flex;\n          flex-direction: column;\n          align-items: center;\n\n          .time-item {\n            padding: 0.5rem 1rem;\n            font-size: 1.5rem;\n            color: $lightTextColor;\n            text-align: center;\n            min-height: 2rem;\n            display: flex;\n            align-items: center;\n            justify-content: center;\n            transition: all 0.2s ease;\n            position: relative;\n            z-index: 2;\n\n            &.selected {\n              color: $darkTextColor;\n              border-radius: 8px;\n            }\n          }\n        }\n        &--period {\n          min-width: 65px;\n          .time-items {\n            display: flex;\n            flex-direction: column;\n            align-items: center;\n            gap: 2rem;\n\n            .time-item {\n              transition: transform 0.2s ease;\n              color: $darkTextColor;\n\n              &:first-child {\n                transform: translateY(-0.5rem);\n\n                &.selected {\n                  transform: translateY(2.5rem);\n                }\n              }\n              &:last-child {\n                transform: translateY(0.5rem);\n\n                &.selected {\n                  transform: translateY(-2.5rem);\n                }\n              }\n            }\n          }\n        }\n      }\n\n      .time-separator {\n        font-size: 1.5rem;\n        font-weight: 600;\n        color: $darkTextColor;\n        user-select: none;\n        z-index: 2;\n      }\n\n      .selected-row-background {\n        position: absolute;\n        left: -16px;\n        right: 0;\n        height: 3.5rem;\n        width: 115%;\n        border-radius: 3px;\n        background-color: #f5f5f5;\n        z-index: 1;\n        top: 50%;\n        transform: translateY(-50%);\n      }\n    }\n  }\n\n  &__footer {\n    padding: 1.5rem;\n    border-top: 1px solid $gray;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
